import { c as _c } from "react/compiler-runtime";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { classNames } from "../../utils";
import { Link } from "../Link";
import { TextBody, TextHeading } from "../Text";
const MB_CLASS_NAME = classNames("mb-1.5 last:mb-0 lg:mb-3");
export const Markdown = t0 => {
  const $ = _c(12);
  const {
    children,
    className,
    components
  } = t0;
  let baseComponents;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const sharedClassName = classNames("w-fit");
    baseComponents = {
      a: _temp,
      img: _temp2,
      iframe: _temp3,
      p: props => <TextBody asChild={true} className={classNames(sharedClassName, MB_CLASS_NAME, "whitespace-pre-wrap")}><p {...props} /></TextBody>,
      span: _temp4,
      li: props_1 => <li className={classNames(sharedClassName, "list-item list-disc whitespace-pre-wrap")}><TextBody asChild={true} size="sm"><span {...props_1} /></TextBody></li>,
      ul: t1 => {
        const {
          className: className_0,
          ...props_2
        } = t1;
        return <ul className={classNames(className_0, sharedClassName, MB_CLASS_NAME, "inline-block list-inside list-disc")} {...props_2} />;
      },
      ol: t2 => {
        const {
          className: className_1,
          ...props_3
        } = t2;
        return <ol className={classNames(className_1, MB_CLASS_NAME, sharedClassName, "inline-block list-inside list-decimal")} {...props_3} />;
      }
    };
    ["h1", "h2", "h3", "h4", "h5", "h6"].forEach(tag => {
      baseComponents[tag] = _temp5;
    });
    $[0] = baseComponents;
  } else {
    baseComponents = $[0];
  }
  let t1;
  if ($[1] !== className) {
    t1 = classNames("last:mb-0", className);
    $[1] = className;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== components) {
    t2 = {
      ...baseComponents,
      ...components
    };
    $[3] = components;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [remarkGfm];
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== children || $[7] !== t2) {
    t4 = <ReactMarkdown components={t2} remarkPlugins={t3} skipHtml={true}>{children}</ReactMarkdown>;
    $[6] = children;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t4) {
    t5 = <div className={t1} data-id="Markdown">{t4}</div>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
function _temp(t0) {
  const {
    children: children_0,
    href
  } = t0;
  return <Link className="whitespace-pre-wrap" href={href} rel="noopener noreferrer" target="_blank" variant="default">{children_0}</Link>;
}
function _temp2() {
  return null;
}
function _temp3() {
  return null;
}
function _temp4(props_0) {
  return <TextBody asChild={true} className="whitespace-pre-wrap"><span {...props_0} /></TextBody>;
}
function _temp5(t0) {
  const {
    children: children_1
  } = t0;
  return <TextHeading asChild={true} size="sm" style={{
    marginBottom: 16
  }}><h2>{children_1}</h2></TextHeading>;
}